import {
  convert,
  valueOrNull,
  newDate
} from '@/sui/data/flatten/tools'

import {
  findSurveillance,
  initializeSurveillance,
  unitType
} from '@/sui/data/flatten/common'

function addCompliancesToResult (result, p) {
  result.p1_conformite_tenue_hdm = p.f.p1_conformite_tenue_hdm
  result.p1_casaques_sterile = p.f.p1_casaques_sterile
  result.p1_masque_conforme = p.f.p1_masque_conforme
  result.p1_coiffe_conforme = p.f.p1_coiffe_conforme
  result.p1_asepsie_conforme = p.f.p1_asepsie_conforme
  result.p1_conformite_tenue_patient = p.f.p1_conformite_tenue_patient
  result.p1_patient_tenue_propre = p.f.p1_patient_tenue_propre
  result.p1_patient_coiffe_conforme = p.f.p1_patient_coiffe_conforme
  result.p1_patient_masque_conforme = p.f.p1_patient_masque_conforme
  result.p1_conformite_prepa_cutanee = p.f.p1_conformite_prepa_cutanee
  result.p1_nettoyage_conforme = p.f.p1_nettoyage_conforme
  result.p1_compresses_conformes = p.f.p1_compresses_conformes
  result.p1_antiseptique_chl_2pourcents = p.f.p1_antiseptique_chl_2pourcents
  result.p1_sechage_spontane = p.f.p1_sechage_spontane
  result.p1_conformite_echoguidage = p.f.p1_conformite_echoguidage
  result.p1_gel_gaine_sterile = p.f.p1_gel_gaine_sterile
  result.p1_echoguidage_asepsie_conforme = p.f.p1_echoguidage_asepsie_conforme
  result.p1_nettoyage_enfant_conforme = p.f.p1_nettoyage_enfant_conforme
  result.p1_antiseptique_alcoolique = p.f.p1_antiseptique_alcoolique

  result.p2_conformite_tenue_hdm = p.f.p2_conformite_tenue_hdm
  result.p2_tenue_propre = p.f.p2_tenue_propre
  result.p2_asepsie_conforme = p.f.p2_asepsie_conforme
  result.p2_deux_hdm_conformes = p.f.p2_deux_hdm_conformes
  result.p2_gants_steriles_si_palpation = p.f.p2_gants_steriles_si_palpation
  result.p2_conformite_tenue_patient = p.f.p2_conformite_tenue_patient
  result.p2_conformite_prepa_cutanee = p.f.p2_conformite_prepa_cutanee
  result.p2_nettoyage_conforme = p.f.p2_nettoyage_conforme
  result.p2_compresses_conformes = p.f.p2_compresses_conformes
  result.p2_antiseptique_alcoolique = p.f.p2_antiseptique_alcoolique
  result.p2_sechage_spontane = p.f.p2_sechage_spontane
  result.p2_enfants_nettoyage_conforme = p.f.p2_enfants_nettoyage_conforme
  result.p2_premiere_hdm_conforme = p.f.p2_premiere_hdm_conforme
  result.p2_seconde_hdm_conforme = p.f.p2_seconde_hdm_conforme
  result.p2_gants = p.f.p2_gants
  result.p2_gants_bon_moment = p.f.p2_gants_bon_moment

  result.p3_conformite_tenue_hdm = p.f.p3_conformite_tenue_hdm
  result.p3_tenue_propre = p.f.p3_tenue_propre
  result.p3_coiffe_conforme = p.f.p3_coiffe_conforme
  result.p3_masque_conforme = p.f.p3_masque_conforme
  result.p3_asepsie_conforme = p.f.p3_asepsie_conforme
  result.p3_conformite_tenue_patient = p.f.p3_conformite_tenue_patient
  result.p3_patient_tenue_propre = p.f.p3_patient_tenue_propre
  result.p3_patient_masque_ou_tourne = p.f.p3_patient_masque_ou_tourne
  result.p3_conformite_prepa_cutanee = p.f.p3_conformite_prepa_cutanee
  result.p3_nettoyage_conforme = p.f.p3_nettoyage_conforme
  result.p3_compresses_conformes = p.f.p3_compresses_conformes
  result.p3_antiseptique_alcoolique = p.f.p3_antiseptique_alcoolique
  result.p3_sechage_spontane = p.f.p3_sechage_spontane
  result.p3_enfants_nettoyage_conforme = p.f.p3_enfants_nettoyage_conforme
  result.p3_premiere_hdm_conforme = p.f.p3_premiere_hdm_conforme
  result.p3_seconde_hdm_conforme = p.f.p3_seconde_hdm_conforme
  result.p3_gants = p.f.p3_gants

  result.p4_conformite_tenue_hdm = p.f.p4_conformite_tenue_hdm
  result.p4_tenue_propre = p.f.p4_tenue_propre
  result.p4_asepsie_conforme = p.f.p4_asepsie_conforme
  result.p4_conformite_tenue_patient = p.f.p4_conformite_tenue_patient
  result.p4_conformite_prepa_cutanee = p.f.p4_conformite_prepa_cutanee
  result.p4_nettoyage_conforme = p.f.p4_nettoyage_conforme
  result.p4_compresses_conformes = p.f.p4_compresses_conformes
  result.p4_antiseptique_alcoolique = p.f.p4_antiseptique_alcoolique
  result.p4_sechage_spontane = p.f.p4_sechage_spontane
  result.p4_premiere_hdm_conforme = p.f.p4_premiere_hdm_conforme
  result.p4_seconde_hdm_conforme = p.f.p4_seconde_hdm_conforme
  result.p4_gants = p.f.p4_gants

  result.b1_conformite_tenue_hdm = p.f.b1_conformite_tenue_hdm
  result.b1_tenue_propre = p.f.b1_tenue_propre
  result.b1_asepsie_conforme = p.f.b1_asepsie_conforme
  result.b1_conformite_prepa_site = p.f.b1_conformite_prepa_site
  result.b1_compresses_conformes = p.f.b1_compresses_conformes
  result.b1_alcool_70 = p.f.b1_alcool_70
  result.b1_desinf_valve = p.f.b1_desinf_valve
  result.b1_tech_desinf_valve = p.f.b1_tech_desinf_valve
  result.b1_valve_alcool_70 = p.f.b1_valve_alcool_70
  result.b1_gants = p.f.b1_gants

  result.b2_conformite_tenue_hdm = p.f.b2_conformite_tenue_hdm
  result.b2_tenue_propre = p.f.b2_tenue_propre
  result.b2_masque_conforme = p.f.b2_masque_conforme
  result.b2_asepsie_conforme = p.f.b2_asepsie_conforme
  result.b2_conformite_tenue_patient = p.f.b2_conformite_tenue_patient
  result.b2_patient_tenue_propre = p.f.b2_patient_tenue_propre
  result.b2_patient_masque_ou_tourne = p.f.b2_patient_masque_ou_tourne
  result.b2_conformite_prepa_site = p.f.b2_conformite_prepa_site
  result.b2_compresses_conformes = p.f.b2_compresses_conformes
  result.b2_alcool_70 = p.f.b2_alcool_70
  result.b2_desinf_valve = p.f.b2_desinf_valve
  result.b2_tech_desinf_valve = p.f.b2_tech_desinf_valve
  result.b2_valve_alcool_70 = p.f.b2_valve_alcool_70

  result.r1_conformite_tenue_hdm = p.f.r1_conformite_tenue_hdm
  result.r1_tenue_propre = p.f.r1_tenue_propre
  result.r1_coiffe_conforme = p.f.r1_coiffe_conforme
  result.r1_masque_conforme = p.f.r1_masque_conforme
  result.r1_asepsie_conforme = p.f.r1_asepsie_conforme
  result.r1_conformite_tenue_patient = p.f.r1_conformite_tenue_patient
  result.r1_conformite_prepa_cutanee = p.f.r1_conformite_prepa_cutanee
  result.r1_nettoyage_conforme = p.f.r1_nettoyage_conforme
  result.r1_nettoyage_systematique = p.f.r1_nettoyage_systematique
  result.r1_antiseptique_chl_2pourcents = p.f.r1_antiseptique_chl_2pourcents
  result.r1_compresses_conformes = p.f.r1_compresses_conformes
  result.r1_antiseptique_alcoolique = p.f.r1_antiseptique_alcoolique
  result.r1_sechage_spontane = p.f.r1_sechage_spontane
}

function addIndicatorsToResult (result, p) {
  result.p1i_conformite_tenue_hdm_in_ctr = p.f.p1i_conformite_tenue_hdm_in_ctr
  result.p1i_conformite_tenue_hdm_in_MIDlines_avec_PI = p.f.p1i_conformite_tenue_hdm_in_MIDlines_avec_PI
  result.p1i_conformite_tenue_patient_in_ctr = p.f.p1i_conformite_tenue_patient_in_ctr
  result.p1i_conformite_tenue_patient_in_MIDlines_avec_PI = p.f.p1i_conformite_tenue_patient_in_MIDlines_avec_PI
  result.p1i_conformite_prepa_cutanee_in_ctr = p.f.p1i_conformite_prepa_cutanee_in_ctr
  result.p1i_conformite_prepa_cutanee_in_MIDlines_avec_PI = p.f.p1i_conformite_prepa_cutanee_in_MIDlines_avec_PI
  result.p2i_conformite_tenue_hdm_in_cvp = p.f.p2i_conformite_tenue_hdm_in_cvp
  result.p2i_conformite_prepa_cutanee_in_cvp = p.f.p2i_conformite_prepa_cutanee_in_cvp
  result.b2i_conformite_tenue_hdm_in_ctr = p.f.b2i_conformite_tenue_hdm_in_ctr
  result.b2i_conformite_tenue_hdm_in_MIDlines_avec_PI = p.f.b2i_conformite_tenue_hdm_in_MIDlines_avec_PI
  result.b2i_conformite_tenue_patient_in_ctr = p.f.b2i_conformite_tenue_patient_in_ctr
  result.b2i_conformite_tenue_patient_in_MIDlines_avec_PI = p.f.b2i_conformite_tenue_patient_in_MIDlines_avec_PI
  result.b2i_conformite_prepa_site_in_ctr = p.f.b2i_conformite_prepa_site_in_ctr
  result.b2i_conformite_prepa_site_in_MIDlines_avec_PI = p.f.b2i_conformite_prepa_site_in_MIDlines_avec_PI
  result.r1i_conformite_tenue_hdm_in_ctr = p.f.r1i_conformite_tenue_hdm_in_ctr
  result.r1i_conformite_tenue_hdm_in_MIDlines_avec_PI = p.f.r1i_conformite_tenue_hdm_in_MIDlines_avec_PI
  result.r1i_conformite_tenue_patient_in_ctr = p.f.r1i_conformite_tenue_patient_in_ctr
  result.r1i_conformite_tenue_patient_in_MIDlines_avec_PI = p.f.r1i_conformite_tenue_patient_in_MIDlines_avec_PI
  result.r1i_conformite_prepa_cutanee_in_ctr = p.f.r1i_conformite_prepa_cutanee_in_ctr
  result.r1i_conformite_prepa_cutanee_in_MIDlines_avec_PI = p.f.r1i_conformite_prepa_cutanee_in_MIDlines_avec_PI
}

function flatten2020 (result, p, s) {
  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.audited = p.f.audited
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.hand_hygiene = p.f.handHygiene
  result.hand_hygiene_type = p.f.handHygieneType
  result.hand_hygiene_compliant = p.f.handHygieneCompliant
  result.secondary_hand_hygiene = p.f.secondaryHandHygiene
  result.secondary_hand_hygiene_type = p.f.secondaryHandHygieneType
  result.secondary_hand_hygiene_compliant = p.f.secondaryHandHygieneCompliant
  result.dirty_skin = p.f.dirtySkin
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.sterile_compresses = p.f.sterileCompresses
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages
  result.dry = p.f.dry
  result.hold_tissue = p.f.holdTissue
  result.sterile_gloves = p.f.sterileGloves
  result.gloves = valueOrNull(
    p.f.gloves, p.f.obsManagment !== 1 && p.f.obsManagment !== 7
  )
  result.gloves_type = valueOrNull(
    p.f.glovesType, p.f.obsManagment !== 1 && p.f.obsManagment !== 7
  )
  result.gloves_justified = p.f.glovesJustified
  result.palpation = p.f.palpation
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_HHC = p.f.whyNotHHC
  result.why_not_HHC_detail = p.f.whyNotHHCDetail
  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HHP = p.f.whyNotHHP
  result.why_not_HHP_detail = p.f.whyNotHHPDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function flatten2021 (result, p, s) {
  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.obs_date = newDate(p.f.obsDate)

  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.other_catheter_type = p.f.otherCatheterType
  result.audited = p.f.audited
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.hand_hygiene = p.f.handHygiene
  result.hand_hygiene_type = p.f.handHygieneType
  result.hand_hygiene_compliant = p.f.handHygieneCompliant
  result.secondary_hand_hygiene = p.f.secondaryHandHygiene
  result.secondary_hand_hygiene_type = p.f.secondaryHandHygieneType
  result.secondary_hand_hygiene_compliant = p.f.secondaryHandHygieneCompliant
  result.dirty_skin = p.f.dirtySkin
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.use_compresses = p.f.useCompresses
  result.compresses_type = p.f.compressesType
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic_compliant = p.f.valveAntisepticCompliant
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages_v2
  result.dry = p.f.dry
  result.hold_tissue = p.f.holdTissue
  result.gloves = p.f.gloves
  result.gloves_type = p.f.glovesType
  result.gloves_justified = p.f.glovesJustified
  result.palpation = p.f.palpation
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_HHC = p.f.whyNotHHC
  result.why_not_HHC_detail = p.f.whyNotHHCDetail
  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HHP = p.f.whyNotHHP
  result.why_not_HHP_detail = p.f.whyNotHHPDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses_v2
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail_v2
  result.why_not_sterile_compresses = p.f.whyNotSterileCompresses
  result.why_not_sterile_compresses_detail = p.f.whyNotSterileCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function flatten2022 (result, p, s) {
  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.obs_date = newDate(p.f.obsDate)
  result.is_ehpad = p.f.isEhpad
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.other_catheter_type = p.f.otherCatheterType
  result.audited = p.f.audited
  result.audited_detail = p.f.auditedDetail
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.hand_hygiene = p.f.handHygiene
  result.hand_hygiene_type = p.f.handHygieneType
  result.hand_hygiene_compliant = p.f.handHygieneCompliant
  result.secondary_hand_hygiene = p.f.secondaryHandHygiene
  result.secondary_hand_hygiene_type = p.f.secondaryHandHygieneType
  result.secondary_hand_hygiene_compliant = p.f.secondaryHandHygieneCompliant
  result.dirty_skin = p.f.dirtySkin
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.use_compresses = p.f.useCompresses
  result.compresses_type = p.f.compressesType
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic_compliant = p.f.valveAntisepticCompliant
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages_v2
  result.dry = p.f.dry
  result.hold_tissue = p.f.holdTissue
  result.gloves_necessary = p.f.glovesNecessary
  result.gloves = p.f.gloves
  result.gloves_type = p.f.glovesType
  result.gloves_put_on = p.f.glovesPutOn
  result.palpation = p.f.palpation
  result.why_not_sterile_gloves = p.f.whyNotSterileGloves
  result.why_not_sterile_gloves_detail = p.f.whyNotSterileGlovesDetail
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_HHC = p.f.whyNotHHC
  result.why_not_HHC_detail = p.f.whyNotHHCDetail
  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HHP = p.f.whyNotHHP
  result.why_not_HHP_detail = p.f.whyNotHHPDetail
  result.why_not_HH_compliant = p.f.whyNotHHCompliant
  result.why_not_HH_compliant_detail = p.f.whyNotHHCompliantDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses_v2
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail_v2
  result.why_not_sterile_compresses = p.f.whyNotSterileCompresses
  result.why_not_sterile_compresses_detail = p.f.whyNotSterileCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function flatten2023 (result, p, s) {
  const p1 = p.f.obsManagment === 1
  const r1 = p.f.obsManagment === 7
  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.obs_date = newDate(p.f.obsDate)
  result.is_ehpad = p.f.isEhpad
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.other_catheter_type = p.f.otherCatheterType
  result.insertion_site = p.f.insertionSite
  result.insertion_site_detail = p.f.insertionSiteDetail
  result.first_dressing = p.f.firstDressing
  result.insertion_date = newDate(p.f.insertionDate)
  result.last_dressing_date = newDate(p.f.lastDressingDate)
  result.manip_type = p.f.manipType
  result.other_manip_type = p.f.otherManipType
  result.audited = p.f.audited
  result.audited_detail = p.f.auditedDetail
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.r1_audited_clean_outfit_or_protection = p.f.auditedCleanOutfitOrProt
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.with_echo = p.f.withUltrasound
  result.echo_prepared = p.f.ultrasoundPrepared
  result.echo_audited_prepa = p.f.usAuditedPreparation

  result.p1_echo_prepa_hdm = valueOrNull(p.f.secondaryHandHygiene, p1)
  result.p1_echo_prepa_hdm_type = valueOrNull(p.f.secondaryHandHygieneType, p1)
  result.p1_echo_prepa_hdm_compliant = valueOrNull(
    p.f.secondaryHandHygieneCompliant, p1
  )

  result.echo_prepa_wiping = p.f.ultrasoundWipingPrepa
  result.echo_prepa_wiping_product = p.f.ultrasoundWipingPrepaProduct
  result.echo_prepa_wiping_product_detail = p.f.ultrasoundWipingPrepaProductDetail

  result.echo_audited_search = p.f.usAuditedSearch
  result.p1_echo_search_hdm = valueOrNull(p.f.thirdHandHygiene, p1)
  result.p1_echo_search_hdm_type = valueOrNull(p.f.thirdHandHygieneType, p1)
  result.p1_echo_search_hdm_compliant = valueOrNull(p.f.thirdHandHygieneCompliant, p1)
  result.p1_echo_search_gloves = valueOrNull(p.f.secondaryGloves, p1)
  result.p1_echo_search_gloves_type = valueOrNull(p.f.secondaryGlovesType, p1)
  result.p1_echo_search_gloves_removal = valueOrNull(p.f.glovesRemoval, p1)
  result.echo_search_gel_used = p.f.gelUsed
  result.echo_search_vial_opening_date_written = p.f.vialOpeningDateWritten
  result.echo_search_vial_opened_since = p.f.vialOpenedSince
  result.echo_search_sheath = p.f.ultrasoundSheath
  result.echo_search_wiping = p.f.ultrasoundWipingSearch
  result.echo_search_wiping_product = p.f.ultrasoundWipingSearchProduct
  result.echo_search_wiping_product_detail = p.f.ultrasoundWipingSearchProductDetail
  result.echo_search_sheath_removal = p.f.sheathRemoval
  result.stripping_sufficient = p.f.strippingSufficient
  result.bmi = p.f.bmi
  result.scheduled_dressing_repair = p.f.scheduledDressingRepair
  result.soiled_dressing = p.f.soiledDressing
  result.dressing_peels_off = p.f.dressingPeelsOff
  result.dressing_with_compresses = p.f.dressingWithCompresses
  result.sterile_semi_permeable_transparent = p.f.sterileSemiPermeableTransparent

  result.hand_hygiene = valueOrNull(p.f.handHygiene, !p1)
  result.hand_hygiene_type = valueOrNull(p.f.handHygieneType, !p1)
  result.hand_hygiene_compliant = valueOrNull(p.f.handHygieneCompliant, !p1)
  result.secondary_hand_hygiene = valueOrNull(p.f.secondaryHandHygiene, !p1)
  result.secondary_hand_hygiene_type = valueOrNull(p.f.secondaryHandHygieneType, !p1)
  result.secondary_hand_hygiene_compliant = valueOrNull(p.f.secondaryHandHygieneCompliant, !p1)
  result.third_hand_hygiene = valueOrNull(p.f.thirdHandHygiene, !p1)
  result.third_hand_hygiene_type = valueOrNull(p.f.thirdHandHygieneType, !p1)
  result.third_hand_hygiene_compliant = valueOrNull(p.f.thirdHandHygieneCompliant, !p1)
  result.fourth_hand_hygiene = valueOrNull(p.f.fourthHandHygiene, !p1)
  result.fourth_hand_hygiene_type = valueOrNull(p.f.fourthHandHygieneType, !p1)
  result.fourth_hand_hygiene_compliant = valueOrNull(p.f.fourthHandHygieneCompliant, !p1)
  result.fifth_hand_hygiene = valueOrNull(p.f.fifthHandHygiene, !p1)
  result.fifth_hand_hygiene_type = valueOrNull(p.f.fifthHandHygieneType, !p1)
  result.fifth_hand_hygiene_compliant = valueOrNull(p.f.fifthHandHygieneCompliant, !p1)
  result.sterile_preparation = p.f.sterilePreparation
  result.dirty_skin = p.f.dirtySkin

  result.r1_removal_gloves = valueOrNull(p.f.gloves, r1)
  result.r1_removal_gloves_type = valueOrNull(p.f.glovesType, r1)
  result.remove_dressing_by_stretching = p.f.removeDressingByStretching
  result.skin_irritation = p.f.signsOfSkinIrritation
  result.r1_removal_gloves_removal = valueOrNull(p.f.glovesRemoval, r1)
  result.has_stabilizer = p.f.hasStabilizer
  result.change_stabilizer = p.f.changeStabilizer
  result.change_stabilizer_reason = p.f.changeStabilizerReason
  result.r1_stab_gloves = valueOrNull(p.f.secondaryGloves, r1)
  result.r1_stab_gloves_type = valueOrNull(p.f.secondaryGlovesType, r1)
  result.r1_stab_gloves_removal = valueOrNull(p.f.secondaryGlovesRemoval, r1)
  result.dressing_set = p.f.dressingSet
  result.r1_repair_gloves = valueOrNull(p.f.thirdGloves, r1)
  result.r1_repair_gloves_type = valueOrNull(p.f.thirdGlovesType, r1)
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.audited_clean_skin = p.f.auditedCleanSkin
  result.p1_clean_hdm = valueOrNull(p.f.fourthHandHygiene, p1)
  result.p1_clean_hdm_type = valueOrNull(p.f.fourthHandHygieneType, p1)
  result.p1_clean_hdm_compliant = valueOrNull(p.f.fourthHandHygieneCompliant, p1)
  result.p1_clean_gloves = valueOrNull(p.f.thirdGloves, p1)
  result.p1_clean_gloves_type = valueOrNull(p.f.thirdGlovesType, p1)
  result.p1_clean_gloves_removal = valueOrNull(p.f.secondaryGlovesRemoval, p1)
  result.soap = p.f.soap
  result.rinsing = p.f.rincing
  result.drying_with_ste_compresses = p.f.dryingWithSterileCompresses
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.audited_apply_asq = p.f.auditedApplyASQ
  result.p1_asq_hdm = valueOrNull(p.f.fifthHandHygiene, p1)
  result.p1_asq_hdm_type = valueOrNull(p.f.fifthHandHygieneType, p1)
  result.p1_asq_hdm_compliant = valueOrNull(p.f.fifthHandHygieneCompliant, p1)
  result.p1_asq_gloves = valueOrNull(p.f.fourthGloves, p1)
  result.p1_asq_gloves_type = valueOrNull(p.f.fourthGlovesType, p1)
  result.p1_asq_gloves_removal = valueOrNull(p.f.thirdGlovesRemoval, p1)
  result.use_compresses = p.f.useCompresses
  result.compresses_type = p.f.compressesType
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic_compliant = p.f.valveAntisepticCompliant
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages_v2
  result.r1_repair_gloves_removal = valueOrNull(p.f.thirdGlovesRemoval, r1)
  result.r1_impl_gloves = valueOrNull(p.f.fourthGloves, r1)
  result.r1_impl_gloves_type = valueOrNull(p.f.fourthGlovesType, r1)

  result.new_stabilizer = p.f.newStabilizer
  result.anti_peeling_product = p.f.antiPeelingProduct
  result.new_dressing_with_compr = p.f.newDressingWithCompresses
  result.new_dressing_sspt = p.f.newDressingSterileSemiPermeableTransparent
  result.new_dressing_impregnated = p.f.newDressingImpregnated

  result.r1_impl_gloves_removal = valueOrNull(p.f.fourthGlovesRemoval, r1)

  result.p1_echo_prepa_hdm = valueOrNull(p.f.secondaryHandHygiene, p1)
  setHandHygiene(
    result, p, 'p1_hand_hygiene_before_insertion', 'handHygiene', p1
  )
  result.p1_inser_gloves = valueOrNull(p.f.gloves, p1)
  result.p1_inser_gloves_type = valueOrNull(p.f.glovesType, p1)

  result.echo_inser_sheath = p.f.secondUltrasoundSheath
  result.echo_probe_covered = p.f.probeCovered
  result.echo_sheath_just_before = p.f.sheathJustBeforeInsertion
  result.echo_gel_used = p.f.secondGelUsed
  result.echo_gel_applied = p.f.gelApplied
  result.echo_probe_needle_contact = p.f.probeNeedleContact
  result.echo_audited_touch = p.f.auditedTouchProbe
  result.echo_probe_touched_with = p.f.probeTouchedWith
  result.echo_probe_touched_with_detail = p.f.probeTouchedWithDetail

  result.p1_echo_touch_remove_gloves = valueOrNull(p.f.fourthGlovesRemoval, p1)

  result.dry = p.f.dry
  result.hold_tissue = p.f.holdTissue
  result.gloves_necessary = p.f.glovesNecessary
  result.gloves = valueOrNull(p.f.gloves, !p1 && !r1)
  result.gloves_type = valueOrNull(p.f.glovesType, !p1 && !r1)
  result.gloves_put_on = p.f.glovesPutOn
  result.gloves_put_on_manip = p.f.glovesPutOnManip
  result.palpation = p.f.palpation
  result.pre_fenced_sterile_field = p.f.preFencedSterileField
  result.chprox_swabbing = p.f.chpSwabbing
  result.chprox_swab_number = p.f.chpSwabNumber
  result.naked_eye_sheath_inspection = p.f.nakedEyeSheathInspection
  result.probe_inspection = p.f.probeInspection
  result.teared_sheath = p.f.tearedSheath
  result.dirty_probe = p.f.dirtyProbe
  result.probe_cleaned = p.f.probeCleaned
  result.probe_cleaning_method = p.f.probeCleaningMethod
  result.probe_cleaning_method_detail = p.f.probeCleaningMethodDetail
  result.probe_cleaning_product = p.f.probeCleaningProduct
  result.probe_cleaning_product_detail = p.f.probeCleaningProductDetail
  result.why_not_sterile_gloves = p.f.whyNotSterileGloves
  result.why_not_sterile_gloves_detail = p.f.whyNotSterileGlovesDetail
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_HH_after_dressing_removal = p.f.whyNotHHAfterDressingRemoval
  result.why_not_HH_after_dressing_removal_detail = p.f.whyNotHHAfterDressingRemovalDetail
  result.why_not_sterile_gloves_antisepsis = p.f.whyNotSGForAntisepsis
  result.why_not_sterile_gloves_antisepsis_detail = p.f.whyNotSGForAntisepsisDetail
  result.why_sheath_not_removed_after_search = p.f.whySheathNotRemovedAfterSearch
  result.why_sheath_not_removed_after_search_detail = p.f.whySheathNotRemovedAfterSearchDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_HHC = p.f.whyNotHHC
  result.why_not_HHC_detail = p.f.whyNotHHCDetail
  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HHP = p.f.whyNotHHP
  result.why_not_HHP_detail = p.f.whyNotHHPDetail
  result.why_not_HH_compliant = p.f.whyNotHHCompliant
  result.why_not_HH_compliant_detail = p.f.whyNotHHCompliantDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses_v2
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail_v2
  result.why_not_sterile_compresses = p.f.whyNotSterileCompresses
  result.why_not_sterile_compresses_detail = p.f.whyNotSterileCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail
  result.why_not_remove_gloves_after_touch = p.f.whyNotRemoveGlovesAfterTouch
  result.why_not_remove_gloves_after_touch_detail = p.f.whyNotRemoveGlovesAfterTouchDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function setHandHygiene (result, p, k, f, n) {
  result[k] = n ? p.f[f] : null
  result[`${k}_type`] = n ? p.f[`${f}Type`] : null
  result[`${k}_compliant`] = n ? p.f[`${f}Compliant`] : null
}

function flatten2024 (result, p, s) {
  const p1 = p.f.obsManagment === 1
  const p2 = p.f.obsManagment === 2
  const p3 = p.f.obsManagment === 3
  const b1 = p.f.obsManagment === 4
  const b2 = p.f.obsManagment === 5
  const p4 = p.f.obsManagment === 6
  const r1 = p.f.obsManagment === 7
  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.obs_date = newDate(p.f.obsDate)
  result.is_ehpad = p.f.isEhpad
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.other_catheter_type = p.f.otherCatheterType
  result.insertion_site = p.f.insertionSite
  result.insertion_site_detail = p.f.insertionSiteDetail
  result.manip_type = p.f.manipType
  result.other_manip_type = p.f.otherManipType
  result.second_manip_type = p.f.secondManipType
  result.second_other_manip_type = p.f.secondOtherManipType
  result.audited = p.f.audited
  result.audited_detail = p.f.auditedDetail
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.r1_audited_clean_outfit_or_protection = p.f.auditedCleanOutfitOrProt
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.patient_head_sterile_field = p.f.patientHeadSterileField
  result.stripping_sufficient = p.f.strippingSufficient
  result.bmi = p.f.bmi

  result.with_echo = p.f.withUltrasound
  result.echo_audited_search = p.f.usAuditedSearch
  result.echo_search_gel_used = p.f.gelUsed
  result.echo_search_vial_opening_date_written = p.f.vialOpeningDateWritten
  result.echo_search_vial_opened_since = p.f.vialOpenedSince
  result.echo_search_sheath = p.f.ultrasoundSheath
  result.echo_search_sheath_removal = p.f.sheathRemoval
  result.echo_search_wiping = p.f.ultrasoundWipingSearch
  result.echo_search_wiping_product = p.f.ultrasoundWipingSearchProduct
  result.echo_search_wiping_product_detail = p.f.ultrasoundWipingSearchProductDetail
  result.scheduled_dressing_repair = p.f.scheduledDressingRepair
  result.soiled_dressing = p.f.soiledDressing
  result.dressing_peels_off = p.f.dressingPeelsOff

  setHandHygiene(
    result, p, 'r1_hand_hygiene_preparation', 'handHygiene', r1
  )

  result.sterile_preparation = p.f.sterilePreparation
  result.remove_dressing_by_stretching = p.f.removeDressingByStretching
  result.skin_irritation = p.f.signsOfSkinIrritation

  result.r1_removal_gloves = valueOrNull(p.f.gloves, r1)
  result.r1_removal_gloves_type = valueOrNull(p.f.glovesType, r1)
  result.r1_removal_gloves_removal = valueOrNull(p.f.glovesRemoval, r1)

  setHandHygiene(
    result, p, 'p4_hand_hygiene_antisepsis', 'handHygiene', p.f.obsManagment === 6
  )
  setHandHygiene(
    result, p, 'b1_hand_hygiene_disinfection', 'handHygiene', p.f.obsManagment === 4
  )

  result.has_stabilizer = p.f.hasStabilizer
  result.change_stabilizer = p.f.changeStabilizer
  result.change_stabilizer_reason = p.f.changeStabilizerReason

  setHandHygiene(
    result, p, 'r1_hand_hygiene_stabilizer', 'secondaryHandHygiene', r1
  )

  result.r1_stab_gloves = valueOrNull(p.f.secondaryGloves, r1)
  result.r1_stab_gloves_type = valueOrNull(p.f.secondaryGlovesType, r1)
  result.r1_stab_gloves_removal = valueOrNull(p.f.secondaryGlovesRemoval, r1)

  setHandHygiene(
    result, p, 'r1_hand_hygiene_antisepsis', 'fourthHandHygiene', r1
  )

  result.r1_repair_gloves = valueOrNull(p.f.thirdGloves, r1)
  result.r1_repair_gloves_type = valueOrNull(p.f.thirdGlovesType, r1)

  result.dirty_skin = p.f.dirtySkin
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.soap = p.f.soap
  result.rinsing = p.f.rincing
  result.drying_with_ste_compresses = p.f.dryingWithSterileCompresses
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.use_compresses = p.f.useCompresses
  result.compresses_type = p.f.compressesType
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic_compliant = p.f.valveAntisepticCompliant
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages_v2
  result.dry = p.f.dry

  result.r1_repair_gloves_removal = valueOrNull(p.f.thirdGlovesRemoval, r1)

  result.pre_fenced_sterile_field = p.f.preFencedSterileField

  result.p1_gloves = valueOrNull(p.f.gloves, p1)
  result.p1_gloves_type = valueOrNull(p.f.glovesType, p1)
  result.p1_gloves_put_on = valueOrNull(p.f.glovesPutOn, p1)
  result.p2_gloves = valueOrNull(p.f.gloves, p2)
  result.p2_gloves_type = valueOrNull(p.f.glovesType, p2)
  result.p2_gloves_put_on = valueOrNull(p.f.glovesPutOn, p2)
  result.p3_gloves = valueOrNull(p.f.gloves, p3)
  result.p3_gloves_type = valueOrNull(p.f.glovesType, p3)
  result.p3_gloves_put_on = valueOrNull(p.f.glovesPutOn, p3)
  result.p4_gloves = valueOrNull(p.f.gloves, p4)
  result.p4_gloves_type = valueOrNull(p.f.glovesType, p4)
  result.b1_gloves = valueOrNull(p.f.gloves, b1)
  result.b1_gloves_type = valueOrNull(p.f.glovesType, b1)
  result.b2_gloves = valueOrNull(p.f.gloves, b2)
  result.b2_gloves_type = valueOrNull(p.f.glovesType, b2)
  result.b2_gloves_put_on_manip = valueOrNull(p.f.glovesPutOnManip, b2)

  result.palpation = p.f.palpation

  setHandHygiene(
    result, p, 'p1_hand_hygiene_before_insertion_gloves', 'handHygiene', p1
  )
  setHandHygiene(
    result, p, 'p2_hand_hygiene_before_preparation', 'handHygiene',
    p.f.obsManagment === 2
  )
  setHandHygiene(
    result, p, 'p3b2_hand_hygiene_prepa_or_install', 'handHygiene',
    p.f.obsManagment === 3 || p.f.obsManagment === 5
  )
  setHandHygiene(
    result, p, 'p2p4_hand_hygiene_insertion', 'secondaryHandHygiene',
    p.f.obsManagment === 2 || p.f.obsManagment === 6
  )
  setHandHygiene(
    result, p, 'p3_hand_hygiene_before_gloves', 'secondaryHandHygiene',
    p.f.obsManagment === 3
  )
  setHandHygiene(
    result, p, 'b2_hand_hygiene_before_gloves', 'secondaryHandHygiene',
    p.f.obsManagment === 5
  )
  setHandHygiene(
    result, p, 'p3_hand_hygiene_puncture', 'thirdHandHygiene',
    p.f.obsManagment === 3
  )
  setHandHygiene(
    result, p, 'b2_hand_hygiene_manip', 'thirdHandHygiene',
    p.f.obsManagment === 5
  )
  result.hold_tissue = p.f.holdTissue

  setHandHygiene(
    result, p, 'r1_hand_hygiene_implementation', 'thirdHandHygiene', r1
  )

  result.r1_impl_gloves = valueOrNull(p.f.fourthGloves, r1)
  result.r1_impl_gloves_type = valueOrNull(p.f.fourthGlovesType, r1)
  result.echo_inser_sheath = p.f.secondUltrasoundSheath
  result.echo_probe_covered = p.f.probeCovered
  result.echo_sheath_just_before = p.f.sheathJustBeforeInsertion
  result.echo_gel_used = p.f.secondGelUsed
  result.echo_gel_applied = p.f.gelApplied
  result.echo_probe_needle_contact = p.f.probeNeedleContact
  result.echo_audited_touch = p.f.auditedTouchProbe
  result.echo_probe_touched_with = p.f.probeTouchedWith
  result.echo_probe_touched_with_detail = p.f.probeTouchedWithDetail
  result.p1_gloves_removal = valueOrNull(p.f.glovesRemoval, p1)

  result.naked_eye_sheath_inspection = p.f.nakedEyeSheathInspection
  result.probe_inspection = p.f.probeInspection
  result.teared_sheath = p.f.tearedSheath
  result.dirty_probe = p.f.dirtyProbe
  result.probe_cleaned = p.f.probeCleaned
  result.probe_cleaning_method = p.f.probeCleaningMethod
  result.probe_cleaning_method_detail = p.f.probeCleaningMethodDetail
  result.probe_cleaning_product = p.f.probeCleaningProduct
  result.probe_cleaning_product_detail = p.f.probeCleaningProductDetail

  result.why_sheath_not_removed_after_search = p.f.whySheathNotRemovedAfterSearch
  result.why_sheath_not_removed_after_search_detail = p.f.whySheathNotRemovedAfterSearchDetail
  result.why_not_chlorex_alc_2_percent = p.f.whyNotChlAlc2Percent
  result.why_not_chlorex_alc_2_percent_detail = p.f.whyNotChlAlc2PercentDetail
  result.why_not_remove_gloves_after_touch = p.f.whyNotRemoveGlovesAfterTouch
  result.why_not_remove_gloves_after_touch_detail = p.f.whyNotRemoveGlovesAfterTouchDetail
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_sterile_gloves_for_palpation = p.f.whyNotSGForPalpation
  result.why_not_sterile_gloves_for_palpation_detail = p.f.whyNotSGForPalpationDetail
  result.why_not_P2_HH = p.f.whyNotP2HH
  result.why_not_P2_HH_detail = p.f.whyNotP2HHDetail
  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HH_compliant = p.f.whyNotHHCompliant
  result.why_not_HH_compliant_detail = p.f.whyNotHHCompliantDetail
  result.why_not_HH_before_gloves = p.f.whyNotHHBeforeGloves
  result.why_not_HH_before_gloves_detail = p.f.whyNotHHBeforeGlovesDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses_v2
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail_v2
  result.why_not_sterile_compresses = p.f.whyNotSterileCompresses
  result.why_not_sterile_compresses_detail = p.f.whyNotSterileCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail
  result.why_not_sterile_gloves = p.f.whyNotSterileGloves
  result.why_not_sterile_gloves_detail = p.f.whyNotSterileGlovesDetail
  result.why_not_remove_gloves_on_stabilizer_change = p.f.whyNotGROnStabilizerChange
  result.why_not_remove_gloves_on_stabilizer_change_detail = p.f.whyNotGROnStabilizerChangeDetail
  result.why_not_HH_before_antisepsis = p.f.whyNotHHBeforeAntisepsis
  result.why_not_HH_before_antisepsis_detail = p.f.whyNotHHBeforeAntisepsisDetail
  result.why_not_sterile_gloves_antisepsis = p.f.whyNotSGForAntisepsis
  result.why_not_sterile_gloves_antisepsis_detail = p.f.whyNotSGForAntisepsisDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function flatten2025 (result, p, s) {
  const p1 = p.f.obsManagment === 1
  const p2 = p.f.obsManagment === 2
  const p3 = p.f.obsManagment === 3
  const b1 = p.f.obsManagment === 4
  const b2 = p.f.obsManagment === 5
  const p4 = p.f.obsManagment === 6
  const r1 = p.f.obsManagment === 7

  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.obs_date = newDate(p.f.obsDate)
  result.is_ehpad = p.f.isEhpad
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.other_catheter_type = p.f.otherCatheterType
  result.device_usage = p.f.deviceUsage
  result.insertion_site = p.f.insertionSite
  result.insertion_site_detail = p.f.insertionSiteDetail
  result.manip_type = p.f.manipType
  result.other_manip_type = p.f.otherManipType
  result.isolated_rinsing_reason = p.f.isolatedRinsingReason
  result.isolated_rinsing_reason_detail = p.f.isolatedRinsingReasonDetail
  result.audited = p.f.audited
  result.audited_detail = p.f.auditedDetail
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.r1_audited_clean_outfit_or_protection = p.f.auditedCleanOutfitOrProt
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.patient_head_sterile_field = p.f.patientHeadSterileField
  result.stripping_sufficient = p.f.strippingSufficient
  result.bmi = p.f.bmi

  result.with_echo = p.f.withUltrasound
  result.echo_audited_search = p.f.usAuditedSearch
  result.echo_search_gel_used = p.f.gelUsed
  result.echo_search_vial_opening_date_written = p.f.vialOpeningDateWritten
  result.echo_search_vial_opened_since = p.f.vialOpenedSince
  result.echo_search_sheath = p.f.ultrasoundSheath
  result.echo_search_sheath_removal = p.f.sheathRemoval
  result.echo_search_wiping = p.f.ultrasoundWipingSearch
  result.echo_search_wiping_product = p.f.ultrasoundWipingSearchProduct
  result.echo_search_wiping_product_detail = p.f.ultrasoundWipingSearchProductDetail
  result.scheduled_dressing_repair = p.f.scheduledDressingRepair
  result.soiled_dressing = p.f.soiledDressing
  result.dressing_peels_off = p.f.dressingPeelsOff

  setHandHygiene(
    result, p, 'r1_hand_hygiene_preparation', 'handHygiene', r1
  )

  result.sterile_preparation = p.f.sterilePreparation
  result.remove_dressing_by_stretching = p.f.removeDressingByStretching
  result.skin_irritation = p.f.signsOfSkinIrritation

  result.r1_removal_gloves = valueOrNull(p.f.gloves, r1)
  result.r1_removal_gloves_type = valueOrNull(p.f.glovesType, r1)
  result.r1_removal_gloves_removal = valueOrNull(p.f.glovesRemoval, r1)

  setHandHygiene(
    result, p, 'p4_hand_hygiene_antisepsis', 'handHygiene', p4
  )
  setHandHygiene(
    result, p, 'b1_hand_hygiene_disinfection', 'handHygiene', b1
  )

  result.has_stabilizer = p.f.hasStabilizer
  result.change_stabilizer = p.f.changeStabilizer
  result.change_stabilizer_reason = p.f.changeStabilizerReason

  setHandHygiene(
    result, p, 'r1_hand_hygiene_stabilizer', 'secondaryHandHygiene', r1
  )

  result.r1_stab_gloves = valueOrNull(p.f.secondaryGloves, r1)
  result.r1_stab_gloves_type = valueOrNull(p.f.secondaryGlovesType, r1)
  result.r1_stab_gloves_removal = valueOrNull(p.f.secondaryGlovesRemoval, r1)

  setHandHygiene(
    result, p, 'r1_hand_hygiene_antisepsis', 'fourthHandHygiene', r1
  )

  result.r1_repair_gloves = valueOrNull(p.f.thirdGloves, r1)
  result.r1_repair_gloves_type = valueOrNull(p.f.thirdGlovesType, r1)

  result.dirty_skin = p.f.dirtySkin
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.soap = p.f.soap
  result.soapOther = p.f.soapOther
  result.rinsing = p.f.rincing
  result.drying_with_ste_compresses = p.f.dryingWithSterileCompresses
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.use_compresses = p.f.useCompresses
  result.compresses_type = p.f.compressesType
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic_compliant = p.f.valveAntisepticCompliant
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages_v2
  result.dry = p.f.dry

  result.r1_repair_gloves_removal = valueOrNull(p.f.thirdGlovesRemoval, r1)

  result.p1_gloves = valueOrNull(p.f.gloves, p1)
  result.p1_gloves_type = valueOrNull(p.f.glovesType, p1)
  result.p1_gloves_put_on = valueOrNull(p.f.glovesPutOn, p1)
  result.p2_gloves = valueOrNull(p.f.gloves, p2)
  result.p2_gloves_type = valueOrNull(p.f.glovesType, p2)
  result.p2_gloves_put_on = valueOrNull(p.f.glovesPutOn, p2)
  result.p3_gloves = valueOrNull(p.f.gloves, p3)
  result.p3_gloves_type = valueOrNull(p.f.glovesType, p3)
  result.p3_gloves_put_on = valueOrNull(p.f.glovesPutOn, p3)
  result.p4_gloves = valueOrNull(p.f.gloves, p4)
  result.p4_gloves_type = valueOrNull(p.f.glovesType, p4)
  result.b1_gloves = valueOrNull(p.f.gloves, b1)
  result.b1_gloves_type = valueOrNull(p.f.glovesType, b1)
  result.b2_gloves = valueOrNull(p.f.gloves, b2)
  result.b2_gloves_type = valueOrNull(p.f.glovesType, b2)
  result.b2_gloves_put_on_manip = valueOrNull(p.f.glovesPutOnManip, b2)

  result.palpation = p.f.palpation
  result.pre_fenced_sterile_field = p.f.preFencedSterileField

  setHandHygiene(
    result, p, 'p1_hand_hygiene_before_insertion_gloves', 'handHygiene', p1
  )
  setHandHygiene(
    result, p, 'p2_hand_hygiene_before_preparation', 'handHygiene', p2
  )

  setHandHygiene(
    result, p, 'p3b2_hand_hygiene_prepa_or_install', 'handHygiene', p3 || b2
  )
  setHandHygiene(
    result, p, 'p2p4_hand_hygiene_insertion', 'secondaryHandHygiene', p2 || p4
  )
  setHandHygiene(
    result, p, 'p3_hand_hygiene_before_gloves', 'secondaryHandHygiene', p3
  )
  setHandHygiene(
    result, p, 'b2_hand_hygiene_before_gloves', 'secondaryHandHygiene', b2
  )
  setHandHygiene(
    result, p, 'p3_hand_hygiene_puncture', 'thirdHandHygiene', p3
  )
  setHandHygiene(
    result, p, 'b2_hand_hygiene_manip', 'thirdHandHygiene', b2
  )

  result.hold_tissue = p.f.holdTissue
  result.gloves_necessary = p.f.glovesNecessary

  setHandHygiene(
    result, p, 'r1_hand_hygiene_implementation', 'thirdHandHygiene', r1
  )
  result.r1_impl_gloves = valueOrNull(p.f.fourthGloves, r1)
  result.r1_impl_gloves_type = valueOrNull(p.f.fourthGlovesType, r1)
  result.echo_inser_sheath = p.f.secondUltrasoundSheath
  result.echo_probe_covered = p.f.probeCovered
  result.echo_sheath_just_before = p.f.sheathJustBeforeInsertion
  result.echo_gel_used = p.f.secondGelUsed
  result.echo_gel_applied = p.f.gelApplied
  result.echo_probe_needle_contact = p.f.probeNeedleContact
  result.echo_audited_touch = p.f.auditedTouchProbe
  result.echo_probe_touched_with = p.f.probeTouchedWith
  result.echo_probe_touched_with_detail = p.f.probeTouchedWithDetail
  result.p1_gloves_removal = valueOrNull(p.f.glovesRemoval, p1)
  result.p2_gloves_removal = valueOrNull(p.f.glovesRemoval, p2)

  result.rinsing_kt_after_insert = p.f.rinsingAfterCatheterInsertion
  result.rinsing_before_manipulation = p.f.rinsingBeforeManipulation
  result.rinsing_after_manipulation = p.f.rinsingAfterManipulation
  result.rinsing_insertion_gloves_kept_for_rinsing = p.f.insertionGlovesKeptForRinsing
  result.rinsing_syring_capacity = p.f.syringeCapacity
  result.rinsing_syringe_capacity_other = p.f.syringeCapacityOther
  result.rinsing_injected_solution = p.f.injectedRinsingSolution
  result.rinsing_injected_solution_other = p.f.injectedRinsingSolutionOther
  result.rinsing_ready_pre_filled_syringe = p.f.readyPreFilledSyringe
  result.rinsing_single_dose_rinsing_solution = p.f.singleDoseRinsingSolution
  result.rinsing_syringe_prepared_just_before_rinsing = p.f.syringePreparedJustBeforeRinsing
  result.rinsing_by_successive_pushes = p.f.rinsingBySuccessivePushes
  result.rinsing_successive_pushes_count = p.f.rinsingSuccessivePushesCount
  result.rinsing_syringe_eliminated_immediately_after_rinsing = p.f.syringeEliminatedImmediatelyAfterRinsing
  result.rinsing_solution_container_eliminated_immediately_after_rinsing = p.f.solutionContainerEliminatedImmediatelyAfterRinsing

  result.naked_eye_sheath_inspection = p.f.nakedEyeSheathInspection
  result.probe_inspection = p.f.probeInspection
  result.teared_sheath = p.f.tearedSheath
  result.dirty_probe = p.f.dirtyProbe
  result.probe_cleaned = p.f.probeCleaned
  result.probe_cleaning_method = p.f.probeCleaningMethod
  result.probe_cleaning_method_detail = p.f.probeCleaningMethodDetail
  result.probe_cleaning_product = p.f.probeCleaningProduct
  result.probe_cleaning_product_detail = p.f.probeCleaningProductDetail

  result.why_sheath_not_removed_after_search = p.f.whySheathNotRemovedAfterSearch
  result.why_sheath_not_removed_after_search_detail = p.f.whySheathNotRemovedAfterSearchDetail
  result.why_not_chlorex_alc_2_percent = p.f.whyNotChlAlc2Percent
  result.why_not_chlorex_alc_2_percent_detail = p.f.whyNotChlAlc2PercentDetail
  result.why_not_surgical_hand_rubbing = p.f.whyNotSurgicalHandrubbing

  result.why_not_remove_gloves_after_touch = p.f.whyNotRemoveGlovesAfterTouch
  result.why_not_remove_gloves_after_touch_detail = p.f.whyNotRemoveGlovesAfterTouchDetail
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_sterile_gloves_for_palpation = p.f.whyNotSGForPalpation
  result.why_not_sterile_gloves_for_palpation_detail = p.f.whyNotSGForPalpationDetail
  result.why_not_P2_HH = p.f.whyNotP2HH
  result.why_not_P2_HH_detail = p.f.whyNotP2HHDetail

  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HH_compliant = p.f.whyNotHHCompliant
  result.why_not_HH_compliant_detail = p.f.whyNotHHCompliantDetail
  result.why_not_HH_before_gloves = p.f.whyNotHHBeforeGloves
  result.why_not_HH_before_gloves_detail = p.f.whyNotHHBeforeGlovesDetail
  result.why_not_rinsing_done_after_catheter_insertion = p.f.whyNotRinsingDoneAfterCatheterInsertion
  result.why_not_rinsing_done_after_catheter_insertion_detail = p.f.whyNotRinsingDoneAfterCatheterInsertionDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses_v2
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail_v2
  result.why_not_sterile_compresses = p.f.whyNotSterileCompresses
  result.why_not_sterile_compresses_detail = p.f.whyNotSterileCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail
  result.why_not_sterile_gloves = p.f.whyNotSterileGloves
  result.why_not_sterile_gloves_detail = p.f.whyNotSterileGlovesDetail

  result.why_not_remove_gloves_on_stabilizer_change = p.f.whyNotGROnStabilizerChange
  result.why_not_remove_gloves_on_stabilizer_change_detail = p.f.whyNotGROnStabilizerChangeDetail
  result.why_not_HH_before_antisepsis = p.f.whyNotHHBeforeAntisepsis
  result.why_not_HH_before_antisepsis_detail = p.f.whyNotHHBeforeAntisepsisDetail
  result.why_not_sterile_gloves_antisepsis = p.f.whyNotSGForAntisepsis
  result.why_not_sterile_gloves_antisepsis_detail = p.f.whyNotSGForAntisepsisDetail
  result.why_not_rinsing_done_when_manipulating = p.f.whyNotRinsingDoneWhenManipulating
  result.why_not_rinsing_done_when_manipulating_detail = p.f.whyNotRinsingDoneWhenManipulatingDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function flatten2026 (result, p, s) {
  const p1 = p.f.obsManagment === 1
  const p2 = p.f.obsManagment === 2
  const p3 = p.f.obsManagment === 3
  const b1 = p.f.obsManagment === 4
  const b2 = p.f.obsManagment === 5
  const p4 = p.f.obsManagment === 6
  const r1 = p.f.obsManagment === 7
  const p5 = p.f.obsManagment === 8 // +++ ADD

  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.obs_managment = p.f.obsManagment
  result.sheet_number = p.f.sheetNumber
  result.obs_date = newDate(p.f.obsDate)
  result.is_ehpad = p.f.isEhpad
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.fistula = p.f.fistula // +++ ADD
  result.button_hole = p.f.buttonHole // +++ ADD
  result.place = p.f.place
  result.other_place = p.f.otherPlace
  result.catheter_type = p.f.type
  result.other_catheter_type = p.f.otherCatheterType
  result.device_usage = p.f.deviceUsage
  result.with_help = p.f.withHelp // +++ ADD
  result.insertion_site = p.f.insertionSite
  result.insertion_site_detail = p.f.insertionSiteDetail
  result.manip_type = p.f.manipType
  result.other_manip_type = p.f.otherManipType
  result.isolated_rinsing_reason = p.f.isolatedRinsingReason
  result.isolated_rinsing_reason_detail = p.f.isolatedRinsingReasonDetail
  result.injected_product = p.f.injectedProduct // +++ ADD
  result.injected_product_detail = p.f.injectedProductDetail // +++ ADD
  result.audited = p.f.audited
  result.audited_detail = p.f.auditedDetail
  result.student = p.f.student
  result.audited_clean_outfit = p.f.auditedCleanOutfit
  result.audited_overcoat = p.f.auditedOvercoat // +++ ADD
  result.r1_audited_clean_outfit_or_protection = p.f.auditedCleanOutfitOrProt
  result.sterile_gown = p.f.sterileGown
  result.audited_cap = p.f.auditedCap
  result.compliant_audited_cap = p.f.compliantAuditedCap
  result.audited_mask = p.f.auditedMask
  result.compliant_audited_mask = p.f.compliantAuditedMask
  result.audited_eye_protection = p.f.auditedEyeProtection // +++ ADD
  result.is_adult = p.f.isAdult
  result.child_age = p.f.childAge
  result.patient_clean_outfit = p.f.patientCleanOutfit
  result.patient_mask = p.f.patientMask
  result.compliant_patient_mask = p.f.compliantPatientMask
  result.patient_sterile_field = p.f.patientSterileField
  result.patient_other_side = p.f.patientOtherSide
  result.patient_cap = p.f.patientCap
  result.compliant_patient_cap = p.f.compliantPatientCap
  result.patient_head_sterile_field = p.f.patientHeadSterileField
  result.stripping_sufficient = p.f.strippingSufficient
  result.bmi = p.f.bmi

  result.with_echo = p.f.withUltrasound
  result.ultrasound_wiping_before_care = p.f.ultrasoundWipingBeforeCare // +++ ADD
  result.ultrasound_wiping_before_care_product = p.f.ultrasoundWipingBeforeCareProduct // +++ ADD
  result.ultrasound_wiping_before_care_product_detail = p.f.ultrasoundWipingBeforeCareProductDetail // +++ ADD
  result.echo_audited_search = p.f.usAuditedSearch
  result.echo_search_gel_used = p.f.gelUsed
  result.echo_search_vial_opening_date_written = p.f.vialOpeningDateWritten
  result.echo_search_vial_opened_since = p.f.vialOpenedSince
  result.echo_search_sheath = p.f.ultrasoundSheath
  result.echo_search_sheath_removal = p.f.sheathRemoval
  result.scheduled_dressing_repair = p.f.scheduledDressingRepair
  result.soiled_dressing = p.f.soiledDressing
  result.dressing_peels_off = p.f.dressingPeelsOff

  setHandHygiene(
    result, p, 'r1_hand_hygiene_preparation', 'handHygiene', r1
  )

  result.sterile_preparation = p.f.sterilePreparation
  result.remove_dressing_by_stretching = p.f.removeDressingByStretching
  result.skin_irritation = p.f.signsOfSkinIrritation

  result.r1_removal_gloves = valueOrNull(p.f.gloves, r1)
  result.r1_removal_gloves_type = valueOrNull(p.f.glovesType, r1)
  result.r1_removal_gloves_removal = valueOrNull(p.f.glovesRemoval, r1)

  setHandHygiene(
    result, p, 'p4_hand_hygiene_antisepsis', 'handHygiene', p4
  )
  setHandHygiene(
    result, p, 'b1_hand_hygiene_disinfection', 'handHygiene', b1
  )

  result.has_stabilizer = p.f.hasStabilizer
  result.change_stabilizer = p.f.changeStabilizer
  result.change_stabilizer_reason = p.f.changeStabilizerReason

  setHandHygiene(
    result, p, 'r1_hand_hygiene_stabilizer', 'secondaryHandHygiene', r1
  )

  result.r1_stab_gloves = valueOrNull(p.f.secondaryGloves, r1)
  result.r1_stab_gloves_type = valueOrNull(p.f.secondaryGlovesType, r1)
  result.r1_stab_gloves_removal = valueOrNull(p.f.secondaryGlovesRemoval, r1)

  setHandHygiene(
    result, p, 'r1_hand_hygiene_antisepsis', 'fourthHandHygiene', r1
  )

  result.r1_repair_gloves = valueOrNull(p.f.thirdGloves, r1)
  result.r1_repair_gloves_type = valueOrNull(p.f.thirdGlovesType, r1)

  result.dirty_skin = p.f.dirtySkin
  result.insertion_site_cleaned_by_patient = p.f.insertionSiteCleanedByPatient // +++ ADD
  result.insertion_site_cleaned = p.f.insertionSiteCleaned
  result.soap = p.f.soap
  result.soapOther = p.f.soapOther
  result.rinsing = p.f.rincing
  result.drying_with_ste_compresses = p.f.dryingWithSterileCompresses
  result.rinsing_product = p.f.rinsingProduct // +++ ADD
  result.drying_equipment = p.f.dryingEquipment // +++ ADD
  result.antiseptic_applied = p.f.antisepticApplied
  result.antiseptic = p.f.antiseptic
  result.other_antiseptic = p.f.otherAntiseptic
  result.use_compresses = p.f.useCompresses
  result.compresses_type = p.f.compressesType
  result.valve = p.f.valve
  result.valve_antiseptic_applied = p.f.valveAntisepticApplied
  result.valve_antiseptic_compliant = p.f.valveAntisepticCompliant
  result.valve_antiseptic = p.f.valveAntiseptic
  result.valve_antiseptic_other = p.f.valveAntisepticOther
  result.antiseptic_passages = p.f.antisepticPassages_v2
  result.dry = p.f.dry

  result.r1_repair_gloves_removal = valueOrNull(p.f.thirdGlovesRemoval, r1)

  result.p1_gloves = valueOrNull(p.f.gloves, p1)
  result.p1_gloves_type = valueOrNull(p.f.glovesType, p1)
  result.p1_gloves_put_on = valueOrNull(p.f.glovesPutOn, p1)
  result.p2_gloves = valueOrNull(p.f.gloves, p2)
  result.p2_gloves_type = valueOrNull(p.f.glovesType, p2)
  result.p2_gloves_put_on = valueOrNull(p.f.glovesPutOn, p2)
  result.p3_gloves = valueOrNull(p.f.gloves, p3)
  result.p3_gloves_type = valueOrNull(p.f.glovesType, p3)
  result.p3_gloves_put_on = valueOrNull(p.f.glovesPutOn, p3)
  result.p4_gloves = valueOrNull(p.f.gloves, p4)
  result.p4_gloves_type = valueOrNull(p.f.glovesType, p4)
  result.p5_gloves = valueOrNull(p.f.gloves, p5) // +++ ADD
  result.p5_gloves_type = valueOrNull(p.f.glovesType, p5) // +++ ADD
  result.p5_gloves_put_on = valueOrNull(p.f.glovesPutOn, p5) // +++ ADD
  result.b1_gloves = valueOrNull(p.f.gloves, b1)
  result.b1_gloves_type = valueOrNull(p.f.glovesType, b1)
  result.b2_gloves = valueOrNull(p.f.gloves, b2)
  result.b2_gloves_type = valueOrNull(p.f.glovesType, b2)
  result.b2_gloves_put_on_manip = valueOrNull(p.f.glovesPutOnManip, b2)

  result.palpation = p.f.palpation
  result.pre_fenced_sterile_field = p.f.preFencedSterileField

  setHandHygiene(
    result, p, 'p1_hand_hygiene_before_insertion_gloves', 'handHygiene', p1
  )
  setHandHygiene(
    result, p, 'p2_hand_hygiene_before_preparation', 'handHygiene', p2
  )

  setHandHygiene(
    result, p, 'p3p5b2_hand_hygiene_prepa_or_install', 'handHygiene', p3 || b2 || p5 // +++ ADD P5
  )
  setHandHygiene(
    result, p, 'p2p4_hand_hygiene_insertion', 'secondaryHandHygiene', p2 || p4
  )
  setHandHygiene(
    result, p, 'p3_hand_hygiene_before_gloves', 'secondaryHandHygiene', p3
  )
  setHandHygiene(
    result, p, 'b2_hand_hygiene_before_gloves', 'secondaryHandHygiene', b2
  )
  setHandHygiene(
    result, p, 'p5_hand_hygiene_before_gloves', 'secondaryHandHygiene', p5 // +++ ADD
  )
  setHandHygiene(
    result, p, 'p3_hand_hygiene_puncture', 'thirdHandHygiene', p3
  )
  setHandHygiene(
    result, p, 'b2_hand_hygiene_manip', 'thirdHandHygiene', b2
  )

  result.hold_tissue = p.f.holdTissue
  result.gloves_necessary = p.f.glovesNecessary

  setHandHygiene(
    result, p, 'r1_hand_hygiene_implementation', 'thirdHandHygiene', r1
  )
  result.r1_impl_gloves = valueOrNull(p.f.fourthGloves, r1)
  result.r1_impl_gloves_type = valueOrNull(p.f.fourthGlovesType, r1)
  result.echo_inser_sheath = p.f.secondUltrasoundSheath
  result.echo_probe_covered = p.f.probeCovered
  result.echo_gel_used = p.f.secondGelUsed
  result.echo_gel_applied = p.f.gelApplied
  result.echo_probe_needle_contact = p.f.probeNeedleContact
  result.echo_audited_touch = p.f.auditedTouchProbe
  result.echo_probe_touched_with = p.f.probeTouchedWith
  result.echo_probe_touched_with_detail = p.f.probeTouchedWithDetail
  result.p1_gloves_removal = valueOrNull(p.f.glovesRemoval, p1)
  result.p2_gloves_removal = valueOrNull(p.f.glovesRemoval, p2)

  result.rinsing_before_manipulation = p.f.rinsingBeforeManipulation
  result.rinsing_after_manipulation = p.f.rinsingAfterManipulation
  result.rinsing_syring_capacity = p.f.syringeCapacity
  result.rinsing_syringe_capacity_other = p.f.syringeCapacityOther
  result.injected_rinsing_volume = p.f.injectedRinsingVolume // +++ ADD
  result.rinsing_injected_solution = p.f.injectedRinsingSolution
  result.rinsing_injected_solution_other = p.f.injectedRinsingSolutionOther
  result.rinsing_ready_pre_filled_syringe = p.f.readyPreFilledSyringe
  result.rinsing_single_dose_rinsing_solution = p.f.singleDoseRinsingSolution
  result.rinsing_syringe_prepared_just_before_rinsing = p.f.syringePreparedJustBeforeRinsing
  result.rinsing_by_successive_pushes = p.f.rinsingBySuccessivePushes
  result.rinsing_successive_pushes_count = p.f.rinsingSuccessivePushesCount
  result.rinsing_syringe_eliminated_immediately_after_rinsing = p.f.syringeEliminatedImmediatelyAfterRinsing
  result.rinsing_solution_container_eliminated_immediately_after_rinsing = p.f.solutionContainerEliminatedImmediatelyAfterRinsing

  result.naked_eye_sheath_inspection = p.f.nakedEyeSheathInspection
  result.probe_inspection = p.f.probeInspection
  result.teared_sheath = p.f.tearedSheath
  result.dirty_probe = p.f.dirtyProbe
  result.probe_cleaned = p.f.probeCleaned
  result.probe_cleaning_method = p.f.probeCleaningMethod
  result.probe_cleaning_method_detail = p.f.probeCleaningMethodDetail
  result.probe_cleaning_product = p.f.probeCleaningProduct
  result.probe_cleaning_product_detail = p.f.probeCleaningProductDetail

  result.why_sheath_not_removed_after_search = p.f.whySheathNotRemovedAfterSearch
  result.why_sheath_not_removed_after_search_detail = p.f.whySheathNotRemovedAfterSearchDetail
  result.why_not_chlorex_alc_2_percent = p.f.whyNotChlAlc2Percent
  result.why_not_chlorex_alc_2_percent_detail = p.f.whyNotChlAlc2PercentDetail
  result.why_not_surgical_hand_rubbing = p.f.whyNotSurgicalHandrubbing

  result.why_not_remove_gloves_after_touch = p.f.whyNotRemoveGlovesAfterTouch
  result.why_not_remove_gloves_after_touch_detail = p.f.whyNotRemoveGlovesAfterTouchDetail
  result.why_nc_audited_outfit = p.f.whyNCAuditedOutfit
  result.why_nc_audited_outfit_detail = p.f.whyNCAuditedOutfitDetail
  result.why_not_audited_mask = p.f.whyNotAuditedMask
  result.why_not_audited_mask_detail = p.f.whyNotAuditedMaskDetail
  result.why_nc_patient_outfit = p.f.whyNCPatientOutfit
  result.why_nc_patient_outfit_detail = p.f.whyNCPatientOutfitDetail
  result.why_not_alcool = p.f.whyNotAlcool
  result.why_not_alcool_detail = p.f.whyNotAlcoolDetail
  result.why_not_sterile_gloves_for_palpation = p.f.whyNotSGForPalpation
  result.why_not_sterile_gloves_for_palpation_detail = p.f.whyNotSGForPalpationDetail
  result.why_not_sterile_gloves_for_insertion = p.f.whyNotSGForInsertion // +++ ADD
  result.why_not_sterile_gloves_for_insertion_detail = p.f.whyNotSGForInsertionDetail // +++ ADD
  result.why_not_P2_HH = p.f.whyNotP2HH
  result.why_not_P2_HH_detail = p.f.whyNotP2HHDetail

  result.why_not_HH = p.f.whyNotHH
  result.why_not_HH_detail = p.f.whyNotHHDetail
  result.why_not_HH_compliant_prerequisites_not_compliant = p.f.whyNotHHCompliantPrerequisitesNotCompliant // +++ ADD
  result.why_not_HH_compliant_missing_step = p.f.whyNotHHCompliantMissingStep // +++ ADD
  result.why_not_HH_compliant_not_long_enough = p.f.whyNotHHCompliantNotLongEnough // +++ ADD
  result.why_not_HH_compliant_not_enough_gel = p.f.whyNotHHCompliantNotEnoughGel // +++ ADD
  result.why_not_HH_compliant_detail = p.f.whyNotHHCompliantDetail
  result.why_not_HH_before_gloves = p.f.whyNotHHBeforeGloves
  result.why_not_HH_before_gloves_detail = p.f.whyNotHHBeforeGlovesDetail
  result.why_not_gloves = p.f.whyNotGloves
  result.why_not_gloves_detail = p.f.whyNotGlovesDetail
  result.why_not_HHM = p.f.whyNotHHM
  result.why_not_HHM_detail = p.f.whyNotHHMDetail
  result.why_not_compresses = p.f.whyNotCompresses_v2
  result.why_not_compresses_detail = p.f.whyNotCompressesDetail_v2
  result.why_not_sterile_compresses = p.f.whyNotSterileCompresses
  result.why_not_sterile_compresses_detail = p.f.whyNotSterileCompressesDetail
  result.why_not_disinfect_valve = p.f.whyNotDisinfectValve
  result.why_not_disinfect_valve_detail = p.f.whyNotDisinfectValveDetail
  result.why_not_sterile_gloves = p.f.whyNotSterileGloves
  result.why_not_sterile_gloves_detail = p.f.whyNotSterileGlovesDetail

  result.why_not_remove_gloves_on_stabilizer_change = p.f.whyNotGROnStabilizerChange
  result.why_not_remove_gloves_on_stabilizer_change_detail = p.f.whyNotGROnStabilizerChangeDetail
  result.why_not_HH_before_antisepsis = p.f.whyNotHHBeforeAntisepsis
  result.why_not_HH_before_antisepsis_detail = p.f.whyNotHHBeforeAntisepsisDetail
  result.why_not_sterile_gloves_antisepsis = p.f.whyNotSGForAntisepsis
  result.why_not_sterile_gloves_antisepsis_detail = p.f.whyNotSGForAntisepsisDetail
  result.why_not_rinsing_done_when_manipulating = p.f.whyNotRinsingDoneWhenManipulating
  result.why_not_rinsing_done_when_manipulating_detail = p.f.whyNotRinsingDoneWhenManipulatingDetail

  addCompliancesToResult(result, p)
  addIndicatorsToResult(result, p)
}

function initializeSheet (p, s, f) {
  const result = {
    type: 'observa4',
    surv_id: p.sv
  }

  initializeSurveillance(result, s)
  f(result, p, s)
  return result
}

const reducer = f => (result, p) => {
  const s = findSurveillance(result, p)
  if (s != null && result.p.onlyClosed && s.status !== 'closed') {
    --result.r.length
    return result
  }

  const sheet = initializeSheet(p, s, f)
  if (result.keys == null) {
    result.keys = Object.keys(sheet)
  }

  result.r[result.i++] = sheet
  return result
}

function run (f) {
  return (params) => convert(params, reducer(f), [])
}

export default {
  '2020': run(flatten2020),
  '2021': run(flatten2021),
  '2022': run(flatten2022),
  '2023': run(flatten2023),
  '2024': run(flatten2024),
  '2025': run(flatten2025),
  '2026': run(flatten2026)
}
